import { observer } from 'mobx-react';
import React from 'react';
import { AccessControlCollection } from 'es/app/security/IAccessControlSet';
import useAccessControlAuthorization from 'es/app/security/protected/AccessControlAuthorization';
import Site from 'es/app/business-logic/domain-models/Site';

interface IProps {
    site?: Site;
    requiredAccessControl?: string | AccessControlCollection;

    // I cannot for the life of me figure out the correct types for these :-|
    loadingFallback?: () => any;
    forbiddenFallback?: () => any;
}

const AccessControlGate = observer((props: React.PropsWithChildren<IProps>) => {
    const { requiredAccessControl, site, loadingFallback, forbiddenFallback } = props;
    const permitAccess = useAccessControlAuthorization(requiredAccessControl, site);

    if (permitAccess === null) {
        return (loadingFallback && loadingFallback()) || null;
    }

    if (!permitAccess) {
        return (forbiddenFallback && forbiddenFallback()) || null;
    }

    return <>{props.children}</>;
});

export default AccessControlGate;
